import IconPackage from "components/icons/icn-package.icon";
import Suggestions from 'components/suggestions-list'
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import intl from 'react-intl-universal'
import { Description, IconTitle, Title } from "../styled";
import { Container, Content } from "./styled";

const Orders = ({
  data,
  calcTimelineMaxHeight,
  showCancelConfirm,
  showFormOrder,
  changeValueOrder,
  saveOrder,
  usuarioComPermissaoParaCancelarPedidos,
  isNewFlow,
  linhaProducaoCentro,
  isHourlyPlan,
}) => {
  const [hasOrders, setHasOrders] = useState(false);

  useEffect(() => {
    const _hasOrdersToShow = data.estoqueDetalhe.ListaPedidos.map(
      (x) => x.Pedidos?.length > 0
    ).some((x) => x);
    setHasOrders(_hasOrdersToShow);
  }, [data.estoqueDetalhe.ListaPedidos]);

  return (
    <Container>
      <IconTitle>
        <IconPackage width="30px" />
        <Title>{intl.get("menu.menuGeneral.orders")}</Title>
      </IconTitle>
      {hasOrders ? (
        data.estoqueDetalhe.ListaPedidos.map(
          (x, indexOrigem) =>
            x.Pedidos.length > 0 && (
              <React.Fragment key={`order-${indexOrigem}-${x.Origem}`}>
                <Description>
                  {intl.get("grid-vision.modal.source")}: {x.Origem}
                </Description>
                <Content>
                  <Suggestions
                    isOrder
                    centro={data.estoqueDetalhe?.Centro}
                    data={x.Pedidos}
                    itemHighlighted={data.tipo === "P" ? data.idItemDestacado : ""}
                    itemExpanded={data.itemExpanded}
                    materialAtivo={data.estoqueDetalhe.MaterialAtivo}
                    itemsExpanded={data.itemsExpanded}
                    expandItem={calcTimelineMaxHeight}
                    showCancelConfirm={(item) => showCancelConfirm(item, indexOrigem)}
                    showFormOrder={showFormOrder}
                    changeValueOrder={(name, value, item) =>
                      changeValueOrder(name, value, item, indexOrigem)
                    }
                    saveOrder={saveOrder}
                    usuarioComPermissaoParaCancelarPedidos={usuarioComPermissaoParaCancelarPedidos}
                    isNewFlow={isNewFlow}
                    linhaProducaoCentro={linhaProducaoCentro}
                    isHourlyPlan={isHourlyPlan}
                  />
                </Content>
              </React.Fragment>
            )
        )
      ) : (
        <div style={{ padding: "20px" }}>{intl.get("grid-vision.feedbacks.noOrders")}</div>
      )}
    </Container>
  );
}

Orders.propTypes = {
  data: PropTypes.shape({
    estoqueDetalhe: PropTypes.shape({
      ListaPedidos: PropTypes.array,
      MaterialAtivo: PropTypes.any,
      Centro: PropTypes.string,
    }),
    tipo: PropTypes.string,
    idItemDestacado: PropTypes.string,
    itemExpanded: PropTypes.any,
    itemsExpanded: PropTypes.array,
  }),
  calcTimelineMaxHeight: PropTypes.any,
  showCancelConfirm: PropTypes.func,
  showFormOrder: PropTypes.any,
  changeValueOrder: PropTypes.func,
  saveOrder: PropTypes.any,
  usuarioComPermissaoParaCancelarPedidos: PropTypes.func,
  isNewFlow: PropTypes.bool,
  linhaProducaoCentro: PropTypes.array,
  isHourlyPlan: PropTypes.bool,
};

export default Orders;
